import * as React from 'react';
import ProjectData from 'src/value-objects/ProjectData';
import { baseApiRoute } from 'src/resources/const';
import RichEditContainer from 'src/modules/commons/inputs/rich-edit/RichEdit.container';

export interface ProjectEnvironmentFormComponentProps {
  formData: ProjectData;
  handleChange: (key: string) => (value: string | File | boolean) => void;
  handleRichEditor: (key: string) => (value: string | File | boolean) => void;
}

class ProjectFinancialDataFormComponent extends React.Component<ProjectEnvironmentFormComponentProps> {

  public render(): React.ReactNode {
    return (

      <div>
        <p className="deco-title f-s-26">
          Datos Financieros
        </p>
        <div className="gap-20"/>
        <div className="row">
          <div className="col-md-12">
            <RichEditContainer
              onChange={(value) => this.props.handleRichEditor('environmentDescription')(value)}
              placeholder="Añade la descripción"
              uploadURL={baseApiRoute + '/save-image'}
              value={this.props.formData.environmentDescription}
            />
          </div>
        </div>
        <div className="gap-20"/>
      </div>
    );
  }

}

export default ProjectFinancialDataFormComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/round-information/ProjectFinancialDataForm.component.tsx